import img1 from "../images/s3e2/img1.jpg";
import img2 from "../images/s3e2/img2.jpg";

export const imgS3E2 = [
  {
    id: 2101,
    image: img1
  },
  {
    id: 2102,
    image: img2
  },
];